// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__qffYF","empty":"ModalGraph_empty__3Sbr5"};